import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateAnonUserName } from 'actions/comments';
import { getAnonUserName } from 'utilities/auth';

import Button from 'components/ui-components/button';
import Input from 'components/ui-components/input';

import './styles.less';

const DEFAULT_STATE = {
  anon_user_name: '',
  anon_user_name_error: null,
  guest_name_box: false,
};

const GuestFlow = class extends Component {
  state = DEFAULT_STATE;

  render() {
    const { anon_user_name, anon_user_name_error } = this.state;
    const { buttonStyle } = this.props;

    return (
      <div className="guest-name-box">
        <span className="back-guest" onClick={this.props.resetNoGuestFlow}>
          back
        </span>
        {anon_user_name_error && (
          <p className="error">{anon_user_name_error}</p>
        )}
        <Input
          inputClass="guest-name-input"
          fieldValue={anon_user_name}
          fieldId="guest-name-input"
          fieldLabel="Full Name"
          severity={anon_user_name_error ? 'error' : ''}
          onChange={this.updateAnonUserName}
          onEnter={this.onCompanyEnter}
        />
        <Button
          buttonClass="guest-submit"
          style={buttonStyle}
          buttonType="rp-primary-4"
          value="Post"
          onClicked={this.addComment}
        />
      </div>
    );
  }

  addComment = () => {
    const { anon_user_name } = this.state;

    if (!anon_user_name) {
      this.setState({ anon_user_name_error: 'Please enter a valid name' });

      return;
    }

    this.props.updateAnonUserName(anon_user_name);
    this.props.addComment();
  };

  updateAnonUserName = val => {
    this.setState({ anon_user_name_error: null });
    this.setState({ anon_user_name: val });
  };

  componentDidMount() {
    const anonUserName = getAnonUserName();

    this.props.updateAnonUserName(anonUserName);
    this.setState({
      anon_user_name: anonUserName,
      guest_name_box: true,
      log_in: false,
    });
  }

  resetNoGuestFlow = () => {
    this.setState(DEFAULT_STATE);
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateAnonUserName: anonUserName =>
      dispatch(updateAnonUserName(anonUserName)),
  };
};

export default connect(null, mapDispatchToProps)(GuestFlow);
